exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-cell[data-v-4ec92670]{height:100%;width:100%;overflow:hidden}", ""]);

// exports
